<template>
    <el-dialog title="Adresses" :visible.sync="thisvisible">
        <div class="form-container">
            <el-form
                ref="searchApi"
                label-position="left"
                label-width="150px"
                style="max-width: 500px;"
            >
                <el-form-item v-if="!nouvelleAdresse">
                    <el-button type="primary" @click="handleNouvelleAdresse">
                        Nouvelle Adresse
                    </el-button>
                </el-form-item>
                <el-form-item v-else label="Chercher">
                    <el-input
                        v-model="apisearch"
                        prefix-icon="el-icon-search"
                        clearable
                        placeholder="ex : 11 bis rue Traversière Paris"
                        @input="handleType"
                    />
                </el-form-item>
            </el-form>
            <ul v-if="apisearch" v-loading="searching" class="listadd">
                <li
                    v-for="(feature, index) in features"
                    :key="'feature' + index"
                >
                    {{ feature.properties.label }}
                    <el-button
                        size="mini"
                        type="success"
                        icon="el-icon-plus"
                        @click="handleSelectFeature(index)"
                    />
                </li>
            </ul>
        </div>
        <div v-if="!apisearch" v-loading="loading" class="form-container">
            <el-form
                ref="adresseForm"
                :model="activeAdresse"
                :rules="rules"
                label-position="left"
                label-width="150px"
                style="max-width: 500px;"
            >
                <div v-if="!modifmanuelle">
                    <span v-if="activeAdresse.person">{{ activeAdresse.person }} <br /></span>
                    {{ activeAdresse.housenumber }}
                    {{ activeAdresse.street }} <br />
                    <span v-if="activeAdresse.complement">{{ activeAdresse.complement }} <br /></span>
                    {{ activeAdresse.postcode }}
                    {{ activeAdresse.city }} <br />
                    {{ activeAdresse.country }}
                </div>

                <el-form-item>
                    <el-switch
                        v-model="modifmanuelle"
                        :active-text="messageManuelle"
                    />
                </el-form-item>
                <template v-if="modifmanuelle">
                    <el-form-item
                        label="Personne"
                        prop="person"
                        :error="getErrorForField('person', errors)"
                    >
                        <el-input
                            v-model="activeAdresse.person"
                            placeholder="si autre que l'Allocataire"
                            :disabled="!modifmanuelle"
                        />
                    </el-form-item>
                    <el-form-item
                        label="Numéro"
                        prop="housenumber"
                        :error="getErrorForField('housenumber', errors)"
                    >
                        <el-input
                            v-model="activeAdresse.housenumber"
                            placeholder="ex: 11 bis"
                            :disabled="!modifmanuelle"
                        />
                    </el-form-item>
                    <el-form-item
                        label="Voie*"
                        prop="street"
                        :error="getErrorForField('street', errors)"
                    >
                        <el-input
                            v-model="activeAdresse.street"
                            placeholder="ex: Rue traversière"
                            :disabled="!modifmanuelle"
                        />
                    </el-form-item>
                    <el-form-item
                        label="Complément"
                        prop="complement"
                        :error="getErrorForField('complement', errors)"
                    >
                        <el-input
                            v-model="activeAdresse.complement"
                            placeholder="ex: 2ème étage"
                            :disabled="!modifmanuelle"
                        />
                    </el-form-item>
                    <el-form-item
                        label="Code postal*"
                        prop="postcode"
                        :error="getErrorForField('postcode', errors)"
                    >
                        <el-input
                            v-model="activeAdresse.postcode"
                            placeholder="ex: 75012"
                            :disabled="!modifmanuelle"
                        />
                    </el-form-item>
                   <!--
                    <el-form-item
                        label="INSEE"
                        prop="citycode"
                        :error="getErrorForField('citycode', errors)"
                    >
                        <el-input
                            v-model="activeAdresse.citycode"
                            :disabled="!modifmanuelle"
                        />
                    </el-form-item>
                    -->
                    <el-form-item
                        label="Ville*"
                        prop="city"
                        :error="getErrorForField('city', errors)"
                    >
                        <el-input
                            v-model="activeAdresse.city"
                            placeholder="ex: PARIS"
                            :disabled="!modifmanuelle"
                        />
                    </el-form-item>
                    <el-form-item
                        label="Pays"
                        prop="country"
                        :error="getErrorForField('country', errors)"
                    >
                        <el-input
                            v-model="activeAdresse.country"
                            placeholder="si autre que FRANCE"
                            :disabled="!modifmanuelle"
                        />
                    </el-form-item>
                </template>
                <el-form-item>
                    <el-button type="info" @click="thisvisible = false">
                        Annuler
                    </el-button>
                    <el-button
                        type="primary"
                        :disabled="!cansave"
                        @click="handleSaveAdresse"
                        v-html="noserver ? 'Ajouter' : 'Enregistrer'"
                    />
                </el-form-item>
            </el-form>
        </div>
    </el-dialog>
</template>

<script>
import Resource from "@/api/resource";
const adresseResource = new Resource("adresses");
import AdressesGouv from "@/api/adressesgouv";
const adressesGouvResource = new AdressesGouv();
import Inscription from "@/api/inscription";
const inscriptionResource = new Inscription();

export default {
    name: "Adresses",
    props: {
        isvisible: {
            type: Boolean,
            default: false
        },
        adresse_id: {
            type: Number,
            default: 0
        },
        editAdresse: {
            type: Object,
            default: () => {
                return {};
            }
        },
        column_adresse: {
            type: String,
            default: ""
        },
        noserver: {
            type: Boolean,
            default: false
        },
        parent: {
            type: Object
        }
    },
    data() {
        return {
            activeAdresse: {},
            thisvisible: false,
            loading: false,
            rules: {
                housenumber: {},
                street: {},
                complement: {},
                postcode: {},
                country: {},
                person: {},
                city: {}
            },
            errors: [],
            apisearch: "",
            features: [],
            modifmanuelle: false,
            originalApiId: "",
            nouvelleAdresse: false,
            searching: false
        };
    },
    watch: {
        isvisible(val) {
            if (val) {
                this.thisvisible = val;
                if (this.adresse_id) {
                    this.getAdresse();
                } else if (this.editAdresse.city) {
                    //Object.assign(this.activeAdresse, this.editAdresse);
                    this.activeAdresse = this.editAdresse;
                } else {
                    this.nouvelleAdresse = true;
                }
            }
            // console.log("isvisible nouvelleAdresse" + this.nouvelleAdresse);
        },
        thisvisible(val) {
            if (!val) {
                this.features = [];
                this.apisearch = "";
                this.parent.dialogAdressesVisible = val;
                this.nouvelleAdresse = false;
                this.modifmanuelle = false;
                this.activeAdresse = {};
            }
        }
    },
    computed: {
        cansave() {
            if (this.modifmanuelle || this.nouvelleAdresse) {
                return true;
            }
            return false;
        },
        messageManuelle() {
            if (!this.activeAdresse.apigouv_id && this.nouvelleAdresse) {
                return "Ajout manuel";
            }
            return "Modification manuelle";
        }
    },
    methods: {
        handleNouvelleAdresse() {
            this.activeAdresse = {};
            this.nouvelleAdresse = true;
        },
        async getAdresse() {
            this.loading = true;
            const { data } = await adresseResource.get(this.adresse_id);
            this.activeAdresse = data;
            this.original_apigouv_id = data.apigouv_id;
            this.loading = false;
        },
        handleSaveAdresse() {
            this.errors = [];
            this.loading = true;
            if (this.noserver) {
                //test que champs OK
                inscriptionResource
                    .testadresse(this.activeAdresse)
                    .then(response => {
                        console.log(response);
                        this.$message({
                            message: "Adresse correcte",
                            type: "success",
                            duration: 2 * 1000
                        });
                        this.parent.callbackAdresse(
                            this.activeAdresse,
                            this.column_adresse
                        );
                        this.loading = false;
                        this.thisvisible = false;
                    })
                    .catch(error => {
                        console.log("error");
                        console.log(error.response);
                        if (error.response && error.response.data) {
                            this.errors = error.response.data.errors;
                        }
                        this.updating = false;
                        this.$message({
                            message: "Erreur dans les champs",
                            type: "error",
                            duration: 2 * 1000
                        });
                        this.loading = false;
                    });
                return true;
            }
            if (this.nouvelleAdresse) {
                adresseResource
                    .store(this.activeAdresse)
                    // .then(response => {
                    .then(response => {
                        this.loading = false;
                        this.thisvisible = false;
                        this.$message({
                            message: "Adresse ajoutée",
                            type: "success",
                            duration: 5 * 1000
                        });
                        this.parent.callbackAdresse(
                            response.data.id,
                            response.data.label,
                            this.column_adresse
                        );
                    })
                    .catch(error => {
                        if (error.response && error.response.data) {
                            this.errors = error.response.data.errors;
                        }
                        console.log("error");
                        console.log(error.response);
                        this.loading = false;
                    });
            } else {
                adresseResource
                    .update(this.adresse_id, this.activeAdresse)
                    // .then(response => {
                    .then(response => {
                        this.loading = false;
                        this.parent.callbackAdresse(
                            response.data.id,
                            response.data.label,
                            this.column_adresse
                        );
                        this.thisvisible = false;
                        this.$message({
                            message: "Adresse mise à jour",
                            type: "success",
                            duration: 5 * 1000
                        });
                    })
                    .catch(error => {
                        if (error.response && error.response.data) {
                            this.errors = error.response.data.errors;
                        }
                        console.log("error");
                        console.log(error.response);
                        this.loading = false;
                    });
            }
        },
        getErrorForField(field, errors) {
            if (errors && errors[field]) {
                return errors[field].join(" ");
            }
        },
        handleType() {
            this.searching = true;
            if (this.apisearch.length > 3) {
                adressesGouvResource
                    .search({ q: this.apisearch })
                    .then(response => {
                        // console.log("response");
                        // console.log(response);
                        if (response.data) {
                            this.features = response.data.features;
                        }
                        this.searching = false;
                    })
                    .catch(error => {
                        console.log("error");
                        console.log(error.response);
                        this.$message({
                            message: "Erreur de api.gouv",
                            type: "error",
                            duration: 5 * 1000
                        });
                        this.searching = false;
                    });
            } else {
                this.features = [];
                this.searching = false;
            }
        },
        handleSelectFeature(index) {
            this.apisearch = "";
            this.activeAdresse = this.features[index].properties;
            this.activeAdresse.apigouv_id = this.activeAdresse.id;
            this.activeAdresse.id = null;
            if (
                this.features[index].geometry &&
                this.features[index].geometry.coordinates
            ) {
                this.activeAdresse.lat = this.features[
                    index
                ].geometry.coordinates[1];
                this.activeAdresse.lon = this.features[
                    index
                ].geometry.coordinates[0];
            }
            if (!this.features[index].properties.street) {
                this.activeAdresse.street = this.features[
                    index
                ].properties.name;
            }
        }
    }
};
</script>
